import React, { Fragment, useEffect, useState } from 'react';
import { BsCaretLeftFill, BsCaretRightFill } from 'react-icons/bs';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Datagrid from '../../../table/Datagrid';
import Loading from '../../../loading';

import { translate } from 'react-i18next';

import { isMobile } from 'react-device-detect';
import DatagridHeader from '../../../table/DatagridHeader';

function TblWatchList(props) {
  const [isPc, setIsPc] = useState(false);
  const [isRoom, setIsRoom] = useState(true);
  const [heightTb, setHeightTb] = useState(360);

  const { t, typeIndex, snapshotRequesting, snapshotSuccessful, categoryId } = props;

  useEffect(() => {
    const heightTb = 360 - (typeIndex === 1 ? 0 : typeIndex === 2 ? 100 : 145);
    setHeightTb(heightTb);
  }, [typeIndex]);

  return (
    <Fragment>
      <div className="tbl-fix-header">
        <table className="table table-bordered table-fix">
          <colgroup>
            <col width="5.5%"></col>
            {/** sym */}
            <col width="3.4%"></col>
            {/** tc */}
            <col width="3.4%"></col>
            {/** tran */}
            <col width="3.4%"></col>
            {/** san */}
            <col width="3.4%"></col>
            {/** gia 3 */}
            <col width="3.9%"></col>
            {/** kl 3 */}
            <col width="3.4%"></col>
            {/** giá 2 */}
            <col width="3.9%"></col>
            {/** kl 2 */}
            <col width="3.4%"></col>
            {/** gia 1 */}
            <col width="3.9%"></col>
            {/** kl 1 */}
            <col width="3.4%"></col>
            {/** gia khop */}
            <col width="4.4%"></col>
            {/** kl khop */}
            <col width="3.4%"></col>
            {/** +/- */}
            <col width="3.4%"></col>
            {/** gia 1 */}
            <col width="3.9%"></col>
            {/** kl 1 */}
            <col width="3.4%"></col>
            {/** gia 2 */}
            <col width="3.9%"></col>
            {/** kl 2 */}
            <col width="3.4%"></col>
            {/** gia 3 */}
            <col width="3.9%"></col>
            {/** kl 3 */}
            <col width="6.2%"></col>
            {/** tong kl */}
            <col width="3.8%"></col>
            {/** cao */}
            <col width="3.4%"></col>
            {/** thap */}
            <col width="3.4%"></col>
            {/** tb */}
            <col width="3.5%"></col>
            {/** nn mua */}
            <col width="3.5%"></col>
            {/** nn ban */}
          </colgroup>
          <thead className="bb-1-haft ">
            <DatagridHeader
              isPc={isPc}
              setIsPc={setIsPc}
              isRoom={isRoom}
              setIsRoom={setIsRoom}
              t={t}
              // sortTable={_handleSortData}
            />
          </thead>
        </table>
      </div>
      {snapshotRequesting && <Loading />}
      {!isMobile && !snapshotRequesting && snapshotSuccessful && (
        <PerfectScrollbar style={{ height: `calc(100vh - ${heightTb}px)` }}>
          <Datagrid
            resource={props.snapshot}
            className="table table-bordered table-fix"
            isPc={isPc}
            isRoom={isRoom}
            categoryId={categoryId}
          />
        </PerfectScrollbar>
      )}
      {isMobile && !snapshotRequesting && snapshotSuccessful && (
        <div
          style={{
            width: '100%',
            height: `calc(100vh - ${heightTb}px)`,
            overflowY: 'auto',
          }}
        >
          <Datagrid
            resource={props.snapshot}
            className="table table-bordered table-fix"
            isPc={isPc}
            isRoom={isRoom}
          />
        </div>
      )}
    </Fragment>
  );
}

export default translate('translations')(TblWatchList);
